import React, { useEffect, useRef, useState } from "react";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useFormik } from 'formik';
import { IoClose, IoAdd, IoTrash, IoTime } from "react-icons/io5";

import "./ProjectCreatemodal.css"; // New CSS import
import { AllUsers, createProject } from "../api";






const ProjectCreateModal = ({ id, isOpen, onClose,setOnSuccess,onSuccess }) => {
  const [attachments, setAttachments] = useState(null);
  const [signOffFile, setSignOffFile] = useState(null);
  const [errorMsg, setErrorMsg] = useState(null);
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [showSubProject, setShowSubProject] = useState(false);
  const [showHistoryLogs, setShowHistoryLogs] = useState(false);
  const [showDependency, setShowDependency] = useState(false);
  const attachmentRef = useRef(null);
  const signOffFileRef = useRef(null);
  
  const [allUsers, setAllUsers] = useState([]);
  
  useEffect(() => {
    const apiHelper = async () => {
      try {
      
        
        const users = await AllUsers();
        console.log(users);
        
        setAllUsers(users?.data?.allUsers || [])
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
    
    if (isOpen) {
      apiHelper();
    }
  }, [isOpen]);

  const initialMilestone = {
    id: Date.now().toString(),
    milestoneNotes: '',
    milestonePlannedStartDate: '',
    milestoneActualStartDate: '',
    milestonePlannedCompletionDate: '',
    milestoneActualCompletion: ''
  };

  const projectInitialValues = {
    projectName: '',
    projectType: '',
    projectFor: 'tenant',
    tenantCustomerId: '',
    tenantCustomerName: '',
    projectId: '',
    subProjectId: '',
    description: '',
    assignedOn: new Date().toISOString().split('T')[0],
    assignedTo: '',
    createdOn: new Date().toISOString().split('T')[0],
    createdBy: '',
    budgetAllocated: '',
    plannedStartDate: '',
    plannedEndDate: '',
    actualStartDate: '',
    actualEndDate: '',
    costCenterPO: '',
    profitCenterSO: '',
    projectStatus: '',
    projectPriority: '',
    projectSeverity: '',
    projectDependency: '',
    remainder: '',
    share: '',
    update: '',
    delete: '',
    historyLogs: '',
    riskType: '',
    effort: '',
    cost: '',
    time: '',
    reason: '',
    mitigation: '',
    riskApprovedBy: '',
    milestones: [initialMilestone],
    comments: '',
    attachments: null,
    signOffFile: null,
  };

  const handleFileChange = (event, type) => {
    if (event.target.files && event.target.files.length > 0) {
      if (type === 'attachment') {
        setAttachments(event.target.files[0]);
      } else {
        setSignOffFile(event.target.files[0]);
      }
      setErrorMsg(null);
    }
  };

  const addMilestone = () => {
    projectFormik.setFieldValue('milestones', [
      ...projectFormik.values.milestones,
      {
        ...initialMilestone,
        id: Date.now().toString()
      }
    ]);
  };

  const removeMilestone = (index) => {
    const newMilestones = [...projectFormik.values.milestones];
    newMilestones.splice(index, 1);
    projectFormik.setFieldValue('milestones', newMilestones);
  };

  const updateMilestoneField = (index, field, value) => {
    const newMilestones = [...projectFormik.values.milestones];
    newMilestones[index] = {
      ...newMilestones[index],
      [field]: value
    };
    projectFormik.setFieldValue('milestones', newMilestones);
  };

  const projectFormik = useFormik({
    initialValues: projectInitialValues,
    onSubmit: async (values) => {
      const formData = new FormData();
      
      Object.entries(values).forEach(([key, value]) => {
        if (key === 'milestones') {
          formData.append(key, JSON.stringify(value));
        } else if (key !== 'attachments' && key !== 'signOffFile' && value) {
          formData.append(key, value);
        }
      });
      
      formData.append('communityId', id);
      
      if (attachments) {
        formData.append('attachments', attachments);
      }
      
      if (signOffFile) {
        formData.append('signOffFile', signOffFile);
      }

      setBtnDisabled(true);
      
      try {
        await createProject(formData);
        setOnSuccess(!onSuccess)
        setBtnDisabled(false);
        setAttachments(null);
        setSignOffFile(null);
        if (attachmentRef.current) attachmentRef.current.value = "";
        if (signOffFileRef.current) signOffFileRef.current.value = "";
        setErrorMsg('');
        projectFormik.resetForm();
        onClose();
        toast.success("Project has been created successfully!");
      } catch (error) {
        setBtnDisabled(false);
        setErrorMsg("Error creating project. Please try again.");
        console.error("Project creation error:", error);
      }
    },
  });

  const resetForm = () => {
    projectFormik.resetForm();
    setAttachments(null);
    setSignOffFile(null);
    if (attachmentRef.current) attachmentRef.current.value = "";
    if (signOffFileRef.current) signOffFileRef.current.value = "";
    setErrorMsg(null);
    setShowSubProject(false);
    setShowHistoryLogs(false);
    setShowDependency(false);
  };

  if (!isOpen) return null;

  return (
    <div className="prj_cr_modal_overlay">
      <div className="prj_cr_modal_container">
        <div className="prj_cr_modal_content">
          <div className="prj_cr_modal_header">
            <h5 className="prj_cr_modal_title">Create New Project</h5>
            <div
              className="prj_cr_modal_close_btn"
              aria-label="Close"
              onClick={onClose}
            >
              <IoClose size={24} />
            </div>
          </div>

          <form onSubmit={projectFormik.handleSubmit} encType="multipart/form-data" className="prj_cr_form">
            <div className="prj_cr_modal_body">
              {/* Basic Information Section */}
              <div className="prj_cr_section">
                <div className="prj_cr_section_header">
                  <h6 className="prj_cr_section_title">Basic Information</h6>
                </div>
                
                <div className="prj_cr_form_grid">
                  <div className="prj_cr_form_group">
                    <label htmlFor="projectName" className="prj_cr_form_label">
                      Project Name <span className="prj_cr_required">*</span>
                    </label>
                    <input
                      type="text"
                      className="prj_cr_form_control"
                      id="projectName"
                      name="projectName"
                      value={projectFormik.values.projectName}
                      onChange={projectFormik.handleChange}
                      required
                      placeholder="Enter project name"
                    />
                  </div>

                  <div className="prj_cr_form_group">
                    <label htmlFor="projectType" className="prj_cr_form_label">Project Type</label>
                    <select
                      className="prj_cr_form_select"
                      id="projectType"
                      name="projectType"
                      value={projectFormik.values.projectType}
                      onChange={projectFormik.handleChange}
                    >
                      <option value="">Select Type</option>
                      <option value="internal">Internal</option>
                      <option value="external">External</option>
                      <option value="client">Client</option>
                      <option value="rnd">R&D</option>
                      <option value="maintenance">Maintenance</option>
                    </select>
                  </div>

                  <div className="prj_cr_form_group">
                    <label htmlFor="projectFor" className="prj_cr_form_label">Project For</label>
                    <select
                      className="prj_cr_form_select"
                      id="projectFor"
                      name="projectFor"
                      value={projectFormik.values.projectFor}
                      onChange={projectFormik.handleChange}
                    >
                      <option value="">Select</option>
                      <option value="tenant">Tenant</option>
                      <option value="customer">Customer</option>
                      <option value="internal">Internal</option>
                    </select>
                  </div>

                  <div className="prj_cr_form_group">
                    <label htmlFor="tenantCustomerId" className="prj_cr_form_label">
                      {projectFormik.values.projectFor ? `${projectFormik.values.projectFor.charAt(0).toUpperCase() + projectFormik.values.projectFor.slice(1)} ID` : 'ID'}
                    </label>
                    <input
                      type="text"
                      className="prj_cr_form_control"
                      id="tenantCustomerId"
                      name="tenantCustomerId"
                      value={projectFormik.values.tenantCustomerId}
                      onChange={projectFormik.handleChange}
                      placeholder="Enter ID"
                    />
                  </div>

                  <div className="prj_cr_form_group">
                    <label htmlFor="tenantCustomerName" className="prj_cr_form_label">Name</label>
                    <input
                      type="text"
                      className="prj_cr_form_control"
                      id="tenantCustomerName"
                      name="tenantCustomerName"
                      value={projectFormik.values.tenantCustomerName}
                      onChange={projectFormik.handleChange}
                      placeholder="Enter name"
                    />
                  </div>

                  <div className="prj_cr_form_group">
                    <label htmlFor="projectId" className="prj_cr_form_label">Project ID</label>
                    <input
                      type="text"
                      className="prj_cr_form_control"
                      id="projectId"
                      name="projectId"
                      value={projectFormik.values.projectId}
                      onChange={projectFormik.handleChange}
                      placeholder="Auto-generated or manual"
                    />
                  </div>

                  {/* Sub Project Toggle - Uncomment if needed
                  <div className="prj_cr_form_group_full">
                    <button
                      type="button"
                      className="prj_cr_toggle_btn"
                      onClick={() => setShowSubProject(!showSubProject)}
                    >
                      <IoAdd size={16} className="prj_cr_btn_icon" />
                      {showSubProject ? 'Hide' : 'Add'} Sub Project
                    </button>
                  </div> */}

                  {showSubProject && (
                    <div className="prj_cr_sub_section">
                      <h6 className="prj_cr_sub_section_title">Sub Project Details</h6>
                      <div className="prj_cr_form_grid">
                        <div className="prj_cr_form_group">
                          <label htmlFor="subProjectId" className="prj_cr_form_label">Sub Project ID</label>
                          <input
                            type="text"
                            className="prj_cr_form_control"
                            id="subProjectId"
                            name="subProjectId"
                            value={projectFormik.values.subProjectId}
                            onChange={projectFormik.handleChange}
                            placeholder="Enter sub-project ID"
                          />
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="prj_cr_form_group_full">
                    <label htmlFor="description" className="prj_cr_form_label">Description</label>
                    <textarea
                      className="prj_cr_form_textarea"
                      id="description"
                      name="description"
                      rows={3}
                      value={projectFormik.values.description}
                      onChange={projectFormik.handleChange}
                      placeholder="Enter project description"
                    />
                  </div>
                </div>
              </div>

              {/* Project Team & Dates Section */}
              <div className="prj_cr_section">
                <div className="prj_cr_section_header">
                  <h6 className="prj_cr_section_title">Project Team & Dates</h6>
                </div>

                <div className="prj_cr_form_grid">
                  <div className="prj_cr_form_group">
                    <label htmlFor="assignedOn" className="prj_cr_form_label">Assigned On</label>
                    <input
                      type="date"
                      className="prj_cr_form_control"
                      id="assignedOn"
                      name="assignedOn"
                      value={projectFormik.values.assignedOn}
                      onChange={projectFormik.handleChange}
                    />
                  </div>

                  <div className="prj_cr_form_group">
                    <label htmlFor="assignedTo" className="prj_cr_form_label">
                      Assigned To <span className="prj_cr_required">*</span>
                    </label>
                    <select
                      className="prj_cr_form_select"
                      id="assignedTo"
                      name="assignedTo"
                      value={projectFormik.values.assignedTo}
                      onChange={projectFormik.handleChange}
                      required
                    >
                      <option value="">Select User</option>
                      {allUsers?.map((user) => (
                        <option key={user._id} value={user._id}>
                          {user.profile?.name || user.email || "Unnamed User"}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="prj_cr_form_group">
                    <label htmlFor="createdOn" className="prj_cr_form_label">Created On</label>
                    <input
                      type="date"
                      className="prj_cr_form_control"
                      id="createdOn"
                      name="createdOn"
                      value={projectFormik.values.createdOn}
                      onChange={projectFormik.handleChange}
                    />
                  </div>

                  <div className="prj_cr_form_group">
                    <label htmlFor="createdBy" className="prj_cr_form_label">Created By</label>
                    <input
                      type="text"
                      className="prj_cr_form_control"
                      id="createdBy"
                      name="createdBy"
                      value={projectFormik.values.createdBy}
                      onChange={projectFormik.handleChange}
                      placeholder="Enter creator name"
                    />
                  </div>

                  <div className="prj_cr_form_group">
                    <label htmlFor="plannedStartDate" className="prj_cr_form_label">Planned Start Date</label>
                    <input
                      type="date"
                      className="prj_cr_form_control"
                      id="plannedStartDate"
                      name="plannedStartDate"
                      value={projectFormik.values.plannedStartDate}
                      onChange={projectFormik.handleChange}
                    />
                  </div>

                  <div className="prj_cr_form_group">
                    <label htmlFor="plannedEndDate" className="prj_cr_form_label">Planned End Date</label>
                    <input
                      type="date"
                      className="prj_cr_form_control"
                      id="plannedEndDate"
                      name="plannedEndDate"
                      value={projectFormik.values.plannedEndDate}
                      onChange={projectFormik.handleChange}
                    />
                  </div>

                  <div className="prj_cr_form_group">
                    <label htmlFor="actualStartDate" className="prj_cr_form_label">Actual Start Date</label>
                    <input
                      type="date"
                      className="prj_cr_form_control"
                      id="actualStartDate"
                      name="actualStartDate"
                      value={projectFormik.values.actualStartDate}
                      onChange={projectFormik.handleChange}
                    />
                  </div>

                  <div className="prj_cr_form_group">
                    <label htmlFor="actualEndDate" className="prj_cr_form_label">Actual End Date</label>
                    <input
                      type="date"
                      className="prj_cr_form_control"
                      id="actualEndDate"
                      name="actualEndDate"
                      value={projectFormik.values.actualEndDate}
                      onChange={projectFormik.handleChange}
                    />
                  </div>
                </div>
              </div>

              {/* Financials Section */}
              <div className="prj_cr_section">
                <div className="prj_cr_section_header">
                  <h6 className="prj_cr_section_title">Financial Information</h6>
                </div>

                <div className="prj_cr_form_grid">
                  <div className="prj_cr_form_group">
                    <label htmlFor="budgetAllocated" className="prj_cr_form_label">Budget Allocated</label>
                    <input
                      type="number"
                      className="prj_cr_form_control"
                      id="budgetAllocated"
                      name="budgetAllocated"
                      value={projectFormik.values.budgetAllocated}
                      onChange={projectFormik.handleChange}
                      placeholder="Enter budget amount"
                    />
                  </div>

                  <div className="prj_cr_form_group">
                    <label htmlFor="costCenterPO" className="prj_cr_form_label">Cost Center / PO</label>
                    <input
                      type="text"
                      className="prj_cr_form_control"
                      id="costCenterPO"
                      name="costCenterPO"
                      value={projectFormik.values.costCenterPO}
                      onChange={projectFormik.handleChange}
                      placeholder="Enter cost center or PO number"
                    />
                  </div>

                  <div className="prj_cr_form_group">
                    <label htmlFor="profitCenterSO" className="prj_cr_form_label">Profit Center / SO</label>
                    <input
                      type="text"
                      className="prj_cr_form_control"
                      id="profitCenterSO"
                      name="profitCenterSO"
                      value={projectFormik.values.profitCenterSO}
                      onChange={projectFormik.handleChange}
                      placeholder="Enter profit center or SO number"
                    />
                  </div>
                </div>
              </div>

              {/* Project Status & Management */}
              <div className="prj_cr_section">
                <div className="prj_cr_section_header">
                  <h6 className="prj_cr_section_title">Project Status & Management</h6>
                </div>

                <div className="prj_cr_form_grid">
                  <div className="prj_cr_form_group">
                    <label htmlFor="projectStatus" className="prj_cr_form_label">Project Status</label>
                    <select
                      className="prj_cr_form_select"
                      id="projectStatus"
                      name="projectStatus"
                      value={projectFormik.values.projectStatus}
                      onChange={projectFormik.handleChange}
                    >
                      <option value="">Select Status</option>
                      <option value="planning">Planning</option>
                      <option value="in-progress">In Progress</option>
                      <option value="on-hold">On Hold</option>
                      <option value="completed">Completed</option>
                      <option value="cancelled">Cancelled</option>
                      <option value="delayed">Delayed</option>
                    </select>
                  </div>

                  <div className="prj_cr_form_group">
                    <label htmlFor="projectPriority" className="prj_cr_form_label">Project Priority</label>
                    <select
                      className="prj_cr_form_select"
                      id="projectPriority"
                      name="projectPriority"
                      value={projectFormik.values.projectPriority}
                      onChange={projectFormik.handleChange}
                    >
                      <option value="">Select Priority</option>
                      <option value="low">Low</option>
                      <option value="medium">Medium</option>
                      <option value="high">High</option>
                      <option value="critical">Critical</option>
                    </select>
                  </div>

                  <div className="prj_cr_form_group">
                    <label htmlFor="projectSeverity" className="prj_cr_form_label">Project Severity</label>
                    <select
                      className="prj_cr_form_select"
                      id="projectSeverity"
                      name="projectSeverity"
                      value={projectFormik.values.projectSeverity}
                      onChange={projectFormik.handleChange}
                    >
                      <option value="">Select Severity</option>
                      <option value="low">Low</option>
                      <option value="medium">Medium</option>
                      <option value="high">High</option>
                      <option value="critical">Critical</option>
                    </select>
                  </div>

                  <div className="prj_cr_form_group_full">
                    <button
                      type="button"
                      className="prj_cr_toggle_btn"
                      onClick={() => setShowDependency(!showDependency)}
                    >
                      <IoAdd size={16} className="prj_cr_btn_icon" />
                      {showDependency ? 'Hide' : 'Add'} Project Dependency
                    </button>
                    
                    {showDependency && (
                      <div className="prj_cr_toggle_content">
                        <input
                          type="text"
                          className="prj_cr_form_control"
                          id="projectDependency"
                          name="projectDependency"
                          value={projectFormik.values.projectDependency}
                          onChange={projectFormik.handleChange}
                          placeholder="Enter project dependencies"
                        />
                      </div>
                    )}
                  </div>

                  <div className="prj_cr_form_group">
                    <label htmlFor="remainder" className="prj_cr_form_label">Reminder</label>
                    <select
                      className="prj_cr_form_select"
                      id="remainder"
                      name="remainder"
                      value={projectFormik.values.remainder}
                      onChange={projectFormik.handleChange}
                    >
                      <option value="">Select Reminder</option>
                      <option value="daily">Daily</option>
                      <option value="weekly">Weekly</option>
                      <option value="monthly">Monthly</option>
                      <option value="quarterly">Quarterly</option>
                      <option value="none">None</option>
                    </select>
                  </div>

                  <div className="prj_cr_form_group">
                    <label htmlFor="share" className="prj_cr_form_label">Share With</label>
                    <input
                      type="text"
                      className="prj_cr_form_control"
                      id="share"
                      name="share"
                      value={projectFormik.values.share}
                      onChange={projectFormik.handleChange}
                      placeholder="Enter emails or usernames"
                    />
                  </div>
                </div>
              </div>

              {/* Risk Management Section */}
              <div className="prj_cr_section">
                <div className="prj_cr_section_header">
                  <h6 className="prj_cr_section_title">Risk Management</h6>
                </div>

                <div className="prj_cr_form_grid">
                  <div className="prj_cr_form_group">
                    <label htmlFor="riskType" className="prj_cr_form_label">Risk Type</label>
                    <select
                      className="prj_cr_form_select"
                      id="riskType"
                      name="riskType"
                      value={projectFormik.values.riskType}
                      onChange={projectFormik.handleChange}
                    >
                      <option value="">Select Risk Type</option>
                      <option value="technical">Technical</option>
                      <option value="schedule">Schedule</option>
                      <option value="cost">Cost</option>
                      <option value="resource">Resource</option>
                      <option value="operational">Operational</option>
                      <option value="security">Security</option>
                    </select>
                  </div>

                  <div className="prj_cr_form_group">
                    <label htmlFor="effort" className="prj_cr_form_label">Effort (hours)</label>
                    <input
                      type="number"
                      className="prj_cr_form_control"
                      id="effort"
                      name="effort"
                      value={projectFormik.values.effort}
                      onChange={projectFormik.handleChange}
                      placeholder="Estimated effort in hours"
                    />
                  </div>

                  <div className="prj_cr_form_group">
                    <label htmlFor="cost" className="prj_cr_form_label">Cost Impact ($)</label>
                    <input
                      type="number"
                      className="prj_cr_form_control"
                      id="cost"
                      name="cost"
                      value={projectFormik.values.cost}
                      onChange={projectFormik.handleChange}
                      placeholder="Estimated cost impact"
                    />
                  </div>

                  <div className="prj_cr_form_group">
                    <label htmlFor="time" className="prj_cr_form_label">Time Impact (days)</label>
                    <input
                      type="number"
                      className="prj_cr_form_control"
                      id="time"
                      name="time"
                      value={projectFormik.values.time}
                      onChange={projectFormik.handleChange}
                      placeholder="Estimated time impact in days"
                    />
                  </div>

                  <div className="prj_cr_form_group_full">
                    <label htmlFor="reason" className="prj_cr_form_label">Risk Reason</label>
                    <textarea
                      className="prj_cr_form_textarea"
                      id="reason"
                      name="reason"
                      rows={2}
                      value={projectFormik.values.reason}
                      onChange={projectFormik.handleChange}
                      placeholder="Describe the risk reason"
                    />
                  </div>

                  <div className="prj_cr_form_group_full">
                    <label htmlFor="mitigation" className="prj_cr_form_label">Mitigation Plan</label>
                    <textarea
                      className="prj_cr_form_textarea"
                      id="mitigation"
                      name="mitigation"
                      rows={2}
                      value={projectFormik.values.mitigation}
                      onChange={projectFormik.handleChange}
                      placeholder="Describe the mitigation plan"
                    />
                  </div>

                  <div className="prj_cr_form_group">
                    <label htmlFor="riskApprovedBy" className="prj_cr_form_label">Risk Approved By</label>
                    <input
                      type="text"
                      className="prj_cr_form_control"
                      id="riskApprovedBy"
                      name="riskApprovedBy"
                      value={projectFormik.values.riskApprovedBy}
                      onChange={projectFormik.handleChange}
                      placeholder="Enter approver name"
                    />
                  </div>
                </div>
              </div>

              {/* Milestones Section */}
              <div className="prj_cr_section">
                <div className="prj_cr_milestone_header">
                  <h6 className="prj_cr_section_title">Milestones</h6>
                  <button
                    type="button"
                    className="prj_cr_add_btn"
                    onClick={addMilestone}
                  >
                    <IoAdd size={16} className="prj_cr_btn_icon" />
                    Add Milestone
                  </button>
                </div>

                <div className="prj_cr_milestones_container">
                  {projectFormik.values.milestones.map((milestone, index) => (
                    <div key={milestone.id} className="prj_cr_milestone_card">
                      <div className="prj_cr_milestone_header_row">
                        <h6 className="prj_cr_milestone_title">Milestone {index + 1}</h6>
                        {projectFormik.values.milestones.length > 1 && (
                          <button
                            type="button"
                            className="prj_cr_delete_btn"
                            onClick={() => removeMilestone(index)}
                          >
                            <IoTrash size={14} />
                          </button>
                        )}
                      </div>
                      
                      <div className="prj_cr_form_grid">
                        <div className="prj_cr_form_group_full">
                          <label className="prj_cr_form_label">Milestone Notes</label>
                          <textarea
                            className="prj_cr_form_textarea"
                            value={milestone.milestoneNotes}
                            onChange={(e) => updateMilestoneField(index, 'milestoneNotes', e.target.value)}
                            rows={2}
                            placeholder="Enter milestone description"
                          />
                        </div>
                        
                        <div className="prj_cr_form_group">
                          <label className="prj_cr_form_label">Planned Start Date</label>
                          <input
                            type="date"
                            className="prj_cr_form_control"
                            value={milestone.milestonePlannedStartDate}
                            onChange={(e) => updateMilestoneField(index, 'milestonePlannedStartDate', e.target.value)}
                          />
                        </div>
                        
                        <div className="prj_cr_form_group">
                          <label className="prj_cr_form_label">Actual Start Date</label>
                          <input
                            type="date"
                            className="prj_cr_form_control"
                            value={milestone.milestoneActualStartDate}
                            onChange={(e) => updateMilestoneField(index, 'milestoneActualStartDate', e.target.value)}
                          />
                        </div>
                        
                        <div className="prj_cr_form_group">
                          <label className="prj_cr_form_label">Planned Completion Date</label>
                          <input
                            type="date"
                            className="prj_cr_form_control"
                            value={milestone.milestonePlannedCompletionDate}
                            onChange={(e) => updateMilestoneField(index, 'milestonePlannedCompletionDate', e.target.value)}
                          />
                        </div>
                        
                        <div className="prj_cr_form_group">
                          <label className="prj_cr_form_label">Actual Completion</label>
                          <input
                            type="date"
                            className="prj_cr_form_control"
                            value={milestone.milestoneActualCompletion}
                            onChange={(e) => updateMilestoneField(index, 'milestoneActualCompletion', e.target.value)}
                          />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Comments & Files Section */}
              <div className="prj_cr_section">
                <div className="prj_cr_section_header">
                  <h6 className="prj_cr_section_title">Comments & Files</h6>
                </div>

                <div className="prj_cr_form_grid">
                  <div className="prj_cr_form_group_full">
                    <label htmlFor="comments" className="prj_cr_form_label">Comments</label>
                    <textarea
                      className="prj_cr_form_textarea"
                      id="comments"
                      name="comments"
                      rows={4}
                      value={projectFormik.values.comments}
                      onChange={projectFormik.handleChange}
                      placeholder="Add any additional comments"
                    />
                  </div>

                  <div className="prj_cr_form_group">
                    <label htmlFor="attachment" className="prj_cr_form_label">Attachment</label>
                    <input
                      ref={attachmentRef}
                      id="attachment"
                      type="file"
                      className="prj_cr_file_input"
                      onChange={(e) => handleFileChange(e, 'attachment')}
                      accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png"
                    />
                    <small className="prj_cr_help_text">Upload project-related documents (max 10MB)</small>
                  </div>

                  <div className="prj_cr_form_group">
                    <label htmlFor="signOffFile" className="prj_cr_form_label">Sign Off File</label>
                    <input
                      ref={signOffFileRef}
                      id="signOffFile"
                      type="file"
                      className="prj_cr_file_input"
                      onChange={(e) => handleFileChange(e, 'signoff')}
                      accept=".pdf,.doc,.docx"
                    />
                    <small className="prj_cr_help_text">Upload sign-off document</small>
                  </div>

                  <div className="prj_cr_form_group_full">
                    <button
                      type="button"
                      className="prj_cr_toggle_btn"
                      onClick={() => setShowHistoryLogs(!showHistoryLogs)}
                    >
                      <IoTime size={16} className="prj_cr_btn_icon" />
                      {showHistoryLogs ? 'Hide' : 'View'} History Logs
                    </button>
                    
                    {showHistoryLogs && (
                      <div className="prj_cr_toggle_content">
                        <textarea
                          className="prj_cr_form_textarea"
                          id="historyLogs"
                          name="historyLogs"
                          rows={3}
                          value={projectFormik.values.historyLogs}
                          onChange={projectFormik.handleChange}
                          placeholder="View or add history logs"
                          readOnly
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {errorMsg && (
                <div className="prj_cr_alert prj_cr_alert_danger">
                  {errorMsg}
                  <button type="button" className="prj_cr_alert_close" onClick={() => setErrorMsg(null)}>
                    ×
                  </button>
                </div>
              )}
            </div>

            <div className="prj_cr_modal_footer">
              <button
                type="button"
                className="prj_cr_btn prj_cr_btn_cancel"
                onClick={() => {
                  resetForm();
                  onClose();
                }}
              >
                <IoClose size={16} className="prj_cr_btn_icon" />
                Cancel
              </button>
              <div className="prj_cr_footer_actions">
                <button
                  type="button"
                  className="prj_cr_btn prj_cr_btn_clear"
                  onClick={resetForm}
                >
                  <IoTrash size={16} className="prj_cr_btn_icon" />
                  Clear All
                </button>
                <button
                  type="submit"
                  className={`prj_cr_btn prj_cr_btn_submit ${btnDisabled ? 'prj_cr_btn_disabled' : ''}`}
                  disabled={btnDisabled || !projectFormik.values.projectName}
                >
                  {btnDisabled ? (
                    <>
                      <div className="prj_cr_spinner"></div>
                      Creating...
                    </>
                  ) : (
                    <>
                      <IoAdd size={16} className="prj_cr_btn_icon" />
                      Create Project
                    </>
                  )}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ProjectCreateModal;